export const dataTestIds = {
	// Galería de productos
	'pdp.gallery.slideshow': 'pdp.gallery.slideshow',
	'pdp.gallery.grid': 'pdp.gallery.grid',
	'pdp.gallery.image': 'pdp.gallery.image',
	'pdp.gallery.video': 'pdp.gallery.video',

	// Información del producto
	'pdp.productInfo.tags': 'pdp.productInfo.tags',
	'pdp.productInfo.title': 'pdp.productInfo.title',
	'pdp.productInfo.reference': 'pdp.productInfo.reference',

	// Best seller
	'pdp.bestSeller.tag': 'pdp.bestSeller.tag',

	// Prices
	'pdp.productInfo.price': 'pdp.productInfo.price',
	'pdp.productInfo.price.floating': 'pdp.productInfo.price.floating',

	// Colors
	'pdp.productInfo.colorSelector': 'pdp.productInfo.colorSelector',
	'pdp.productInfo.colorSelector.label': 'pdp.productInfo.colorSelector.label',
	'pdp.colorSelector.link.fn': (colorId: string) =>
		`pdp.colorSelector.${colorId}`,
	'pdp.productInfo.colorSelector.colorList':
		'pdp.productInfo.colorSelector.colorList',
	'pdp.productInfo.colorSelector.colorList.reduced':
		'pdp.productInfo.colorSelector.colorList.reduced',

	// Sizes
	'pdp.productInfo.sizeSelector': 'pdp.productInfo.sizeSelector',
	'pdp.productInfo.sizeSelector.fn': (
		availability: 'sizeAvailable' | 'sizeUnavailable',
		sizeId: string
	) => `pdp.productInfo.sizeSelector.${availability}.${sizeId}`,

	// Actions
	'pdp.productInfo.addToBag': 'pdp.productInfo.addToBag',
	'pdp.productInfo.favorite.active': 'pdp.productInfo.favorite.active',
	'pdp.productInfo.favorite.inactive': 'pdp.productInfo.favorite.inactive',
	'pdp.favorite.floatingBtn.active': 'pdp.favorite.floatingBtn.active',
	'pdp.favorite.floatingBtn.inactive': 'pdp.favorite.floatingBtn.inactive',
	'pdp.productInfo.favorite.active.small':
		'pdp.productInfo.favorite.active.small',
	'pdp.productInfo.favorite.inactive.small':
		'pdp.productInfo.favorite.inactive.small',

	// Shipping and returns
	'pdp.productInfo.shippingAndReturns': 'pdp.productInfo.shippingAndReturns',
	'pdp.productInfo.shippingAndReturns.accordion':
		'pdp.productInfo.shippingAndReturns.accordion',
	'pdp.productInfo.shippingAndReturns.content':
		'pdp.productInfo.shippingAndReturns.content',

	// Product details
	'pdp.productDetails.button': 'pdp.productDetails.button',
	'pdp.productDetails.description': 'pdp.productDetails.description',
	'pdp.productDetails.kcSafety': 'pdp.productDetails.kcSafety',
	'pdp.productDetails.breadcrumbs': 'pdp.productDetails.breadcrumbs',
	'pdp.productDetails.breadcrumbs.list': 'pdp.productDetails.breadcrumbs.list',
	'pdp.productDetails.breadcrumbs.listItem':
		'pdp.productDetails.breadcrumbs.listItem',
	'pdp.sizeGuide': 'pdp.sizeGuide',

	// Composition, origin, care
	'pdp.productDetails.compositionOriginAndCare.accordion':
		'pdp.productDetails.compositionOriginAndCare.accordion',
	'pdp.productDetails.compositionOriginAndCare.content':
		'pdp.productDetails.compositionOriginAndCare.content',
	'pdp.productDetails.compositionOriginAndCare.accordion.content':
		'pdp.productDetails.compositionOriginAndCare.accordion.content',
	'pdp.productDetails.compositionOriginAndCare.origin':
		'pdp.productDetails.compositionOriginAndCare.origin',
	'pdp.productDetails.compositionOriginAndCare.fabricationOrFinish':
		'pdp.productDetails.compositionOriginAndCare.fabricationOrFinish',
	'pdp.productDetails.compositionOriginAndCare.designed':
		'pdp.productDetails.compositionOriginAndCare.designed',
	'pdp.productDetails.compositionOriginAndCare.composition':
		'pdp.productDetails.compositionOriginAndCare.composition',
	'pdp.productDetails.compositionOriginAndCare.washingRules':
		'pdp.productDetails.compositionOriginAndCare.washingRules',
	'pdp.productDetails.compositionOriginAndCare.releasesMicrofibers':
		'pdp.productDetails.compositionOriginAndCare.releasesMicrofibers',
	'pdp.productDetails.compositionOriginAndCare.recyclability':
		'pdp.productDetails.compositionOriginAndCare.recyclability',

	// Cross selling
	'pdp.crossSelling.similars': 'pdp.crossSelling.similars',
	'pdp.crossSelling.totalLook': 'pdp.crossSelling.totalLook',
	'pdp.crossSelling.recommendations': 'pdp.crossSelling.recommendations',
	'pdp.crossSelling.lastViewed': 'pdp.crossSelling.lastViewed',

	// Zoom
	'pdp.zoom.image': 'pdp.zoom.image',
	'pdp.zoom.thumbnails': 'pdp.zoom.thumbnails',

	// Sticky
	'pdp.sticky.favorite.active': 'pdp.sticky.favorite.active',
	'pdp.sticky.favorite.inactive': 'pdp.sticky.favorite.inactive',
	'pdp.sticky.price': 'pdp.sticky.price',
	'pdp.sticky.image': 'pdp.sticky.image',
	'pdp.sticky.title': 'pdp.sticky.title',
	'pdp.sticky.color': 'pdp.sticky.color',
	'pdp.sticky.size': 'pdp.sticky.size',
	'pdp.sticky.addToBag': 'pdp.sticky.addToBag',

	// Share
	'pdp.productInfo.share': 'pdp.productInfo.share',

	// Store finder
	'pdp.productInfo.storeFinder': 'pdp.productInfo.storeFinder',
	'pdp.productInfo.storeFinder.dialog': 'pdp.productInfo.storeFinder.dialog',

	// Tech qualities
	'pdp.techQualities': 'pdp.techQualities',
	'pdp.techQualities.button': 'pdp.techQualities.button',

	// Chatbot
	'pdp.chatbot.button': 'pdp.chatbot.button',

	//Shop the look
	'pdp.shopTheLook.modal': 'pdp.shopTheLook.modal',

	// Video
	'pdp.video.button.play': 'pdp.video.button.play',
	'pdp.video.button.pause': 'pdp.video.button.pause',
}
